import React from "react";
import { WifiOff } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * OfflineBanner — appare quando il device è offline e mostra
 * "Modalità offline — dati aggiornati al [ultima sync]".
 *
 * NON appare se l'utente non è loggato (login screen non ha senso offline-mode).
 */
function formatLastSync(iso) {
  if (!iso) return "qualche minuto fa";
  try {
    const d = new Date(iso);
    const now = new Date();
    const sameDay = d.toDateString() === now.toDateString();
    const time = d.toLocaleTimeString("it-IT", {
      hour: "2-digit",
      minute: "2-digit",
    });
    if (sameDay) return `oggi ${time}`;
    return d.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "short",
    }) + ` ${time}`;
  } catch {
    return "qualche minuto fa";
  }
}

export default function OfflineBanner() {
  const { online, lastSyncAt, user } = useAuth();
  if (online || !user) return null;
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-50 w-full max-w-[420px] px-3"
      style={{ top: "calc(56px + env(safe-area-inset-top))" }}
      data-testid="offline-banner"
    >
      <div className="flex items-center gap-2 rounded-full bg-amber-500/95 text-[#3a1f00] text-[12.5px] font-medium px-3 py-1.5 shadow-lg backdrop-blur-md">
        <WifiOff size={13} />
        <span>
          Modalità offline — dati aggiornati al{" "}
          <strong>{formatLastSync(lastSyncAt)}</strong>
        </span>
      </div>
    </div>
  );
}
